import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { ProductService } from 'src/app/angularJS/services/product/product.service';

/**
 * A controller used to edit a product on a catalogue
 */
export class ProductEditController {
  private static $inject = [
    '$rootScope',
    '$state',
    '$stateParams',
    'UserMessages',
    'ACTToolbarService',
    'catalogueConstants',
    'productService'
  ];

  public required: InterACT.Interfaces.Catalogues.Product;
  public channelAvailableValues: Array<string>;
  public currentSchemaId: string;
  private catalogueId: string;

  constructor(
    private $rootScope,
    private $state: ng.ui.IStateService,
    private $stateParams,
    private UserMessages: UserMessagesService,
    private ActToolbarService: ACTToolbarService,
    private catalogueConstants: InterACT.Interfaces.ICatalogueConstants,
    private productService: ProductService
  ) {
    this.activate();
  }

  /**
   * Edits the product by merging the data entered in the form with the required data
   * @param data the product data entered in the form
   * @returns a promise from the product service
   */
  public editProduct = (data: InterACT.Interfaces.Catalogues.Product) => {
    _.merge(this.required, data);
    if (data.fields) {
      this.required.fields = JSON.parse(JSON.stringify(data.fields, (key, value) => {
        return (value === null ? undefined : value);
    }));
  }
    this.$rootScope.showSpinner = true;
    return this.productService.update(this.catalogueId, this.required.id, this.required).then(() => {
      this.$rootScope.showSpinner = false;
      this.UserMessages.showToast('TOAST_MESSAGE.PRODUCT.EDITED');
      this.exitEditProduct();
    });
  }

  /**
   * Exits the edit product view to the product list view
   * @returns a promise from the state provider
   */
  public exitEditProduct = () => {
    return this.$state.go('catalogue.product-list', {
      catalogueId: this.$stateParams.catalogueId,
      catalogueVersion: this.$stateParams.catalogueVersion
    });
  }

  /**
   * Initialises the controller
   */
  private activate() {
    this.required = this.$stateParams.sourceProduct;
    this.catalogueId = this.$stateParams.sourceCatalogue.id;
    this.currentSchemaId = this.required.type;
    this.channelAvailableValues = this.catalogueConstants.CHANNELS;

    this.ActToolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle('HEADING.PRODUCT.EDIT');
    });

    this.$rootScope.showSpinner = true;
    return this.productService.getProduct(this.catalogueId, this.required.id, {
      expand: true
    }).then((response) => {
      angular.extend(this.required, response);
      this.$rootScope.showSpinner = false;
    });
  }
}
